import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import ImageControlPoint from 'material-ui/svg-icons/image/control-point';
import Common from './Common';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Dialog from 'material-ui/Dialog';

class MediaRelation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      list: [],
      lang: localStorage.getItem("lang"),
      dialogOpen: false
    };
    this.props.parent.mediaRelation = this;
  }

  handleDialogClose() {
    this.setState({
      dialogOpen: false
    });
  }

  handleDialogOpen() {
    this.setState({
      dialogOpen: true
    });
  }

  crossPlatformView() {
    if (this.state.list.length === 0) {
      return (<div></div>);
    }
    else {
      var self = this;
      return (
        <div>
          {
            Common.isMobile() ?
            <FloatingActionButton mini={true} primary={true} style={{'position':'fixed', 'right':'18px', 'bottom':'65px', 'zIndex':10}} onClick={this.handleDialogOpen.bind(this)}>
              <ContentAdd style={{fill:"#000"}}/>
            </FloatingActionButton> :

            <FloatingActionButton mini={true} primary={true} style={{'position':'fixed', 'left':'50%', 'marginLeft':'348px', 'bottom':'95px', 'zIndex':10}} onClick={this.handleDialogOpen.bind(this)}>
              <ContentAdd style={{fill:"#000"}}/>
            </FloatingActionButton>
          }
          <Dialog
              title={Common.getTitleList(this.state.lang)['relationTopic']}
              modal={false}
              open={self.state.dialogOpen}
              onRequestClose={self.handleDialogClose.bind(self)}
              autoScrollBodyContent={true}
          >
            <List>
              {
                this.state.list.map((mediaObj, idx) => {
                  return (
                    <div key={idx}>
                      { idx !== 0 ? <Divider /> : <div></div> }
                      <ListItem
                        primaryText= {<div style={{lineHeight:'24px', marginTop:-8}}>{mediaObj.title}</div>}
                        secondaryText={mediaObj.authorName}
                        onClick={this.playMedia.bind(this, mediaObj)}
                      />
                    </div>
                  );
                })
              }
            </List>
          </Dialog>
        </div>
      );
    }
  }

  loadRelationViewWithMediaObj(mediaObj) {
    if (mediaObj.hasRelation) {
      Common.getMediaRelation(mediaObj._id).then((list) => {
        this.setState({
          list: list,
          lang: localStorage.getItem("lang")
        });
      }, () => {
        this.setState({
          list: []
        });
      });
    }
    else {
      this.setState({
        list: []
      });
    }
  }

  playMedia(mediaObj) {
    this.props.parent.playMedia(mediaObj, -1);
    this.setState({
      dialogOpen: false
    });
  }

  webView() {
    if (this.state.list.length === 0) {
      return (<div></div>);
    }
    else {
      return (
        <Paper zDepth={1} transitionEnabled={false} style={{'position':'fixed', 'top':'85px', 'left':'50%', 'marginLeft':280, 'width':'270px'}}>
          <Subheader style={{fontSize:15}}><ImageControlPoint color="rgba(0, 0, 0, 0.5)" style={{marginBottom:-7, marginRight:12}} />{Common.getTitleList(this.state.lang)['relationTopic']}</Subheader>
          <List style={{'maxHeight':400, 'overflowY':'scroll', marginTop:-8}}>
            {
              this.state.list.map((mediaObj, idx) => {
                return (
                  <div key={idx}>
                    <Divider />
                    <ListItem
                      primaryText= {<div style={{lineHeight:'24px', marginTop:-8}}>{mediaObj.title}</div>}
                      secondaryText={mediaObj.authorName}
                      onClick={this.playMedia.bind(this, mediaObj)}
                    />
                  </div>
                );
              })
            }
          </List>
        </Paper>
      );
    }
  }

  render() {
    return this.crossPlatformView();
  }
}

export default MediaRelation;



// WEBPACK FOOTER //
// ./src/MediaRelation.js